import * as ActionTypes from '../constants/ActionTypes';

const initialState = {
	loading: false,
	loadingSubmit: false,
	caterers: [],
	meta: null
};

export default function reducer(state = initialState, action) {
	switch (action.type) {
		case ActionTypes.GET_RATING_CATERERS_REQUEST:
		case ActionTypes.GET_RATING_CATERERS_SUCCESS:
		case ActionTypes.GET_RATING_CATERERS_ERROR:
		case ActionTypes.SUBMIT_RATING_PAGE_REQUEST:
		case ActionTypes.SUBMIT_RATING_PAGE_SUCCESS:
		case ActionTypes.SUBMIT_RATING_PAGE_ERROR:
			return { ...state, ...action.payload };
		case ActionTypes.RESET_RATING_PAGE_META:
			return { ...state, meta: null };
		case ActionTypes.RESET_RATING_PAGE:
			return { ...initialState };
		default:
			return state;
	}
}
